<template>
    <a style="padding-right:10px">
        <el-button :disabled="disabled" :icon="icon" :type="type" @click="getCaType">
            <slot></slot>
        </el-button>

        <el-dialog title="选择CA" :visible.sync="dialogVisible" width="30%" :append-to-body="true" :show-close="false" :close-on-click-modal="false">
            <my-select placeholder="选择CA" v-model="caType" :data="caList" style="width:100%;">
            </my-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancle">取 消</el-button>
                <el-button type="primary" @click="caChoice">确 定</el-button>
            </span>
        </el-dialog>
    </a>
           
</template>

<script>
import '@/js/ca/hebei/hebcaP11Object2.js'
import '@/js/ca/CAbase.js'

export default {
    props: {
        icon: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        disabled:{
            type:Boolean,
            default: false
        }
    },
    data () {
        return {
            dialogVisible:false,
            caType:'',
            caList: [
                { value: '河北CA', key: 'hebeica' },
            ],
        }
    },
    methods:{
        // 判断是否已使用CA
        getCaType(){
            if(this.caType){
                this.$emit('click',this.caType)
            }else{
                this.caType = 'hebeica'
                this.dialogVisible = true
            }
        },
        // 取消
        cancle(){
            this.caType = '';
            this.dialogVisible = false;
        },
        // 选择ca
        caChoice(){
            var that = this
            setSession({sessionCaType: this.caType})
            // 初始化ca
            useCA(this.caType, 'initialization', '', function (res) {
                that.dialogVisible = false
                that.$emit('click',that.caType)
                
            })

            
        }
    },
    computed: {
        
    },
    mounted() {
        this.caType = getSession('sessionCaType')
        if(this.caType){
            // 初始化ca
            useCA(this.caType, 'initialization', '', function (res) {})
        }else{
            useCA('hebeica', 'initialization', '', function (res) {})
        }
    }
}
</script>

<style scoped lang="scss">
</style>
